import React from 'react';
import TabbedModal from './TabbedModal';
import './ProfileModal.scss';

const ProfileModal = props => <TabbedModal parentBlockClassPrefix="ProfileModal" header="Profile" {...props} />;

export default ProfileModal;
